import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.element.classList.add("is-enhanced")
    this.activate(this.tabTargets.find(tab => tab.getAttribute("aria-selected") === "true") || this.tabTargets[0])
  }

  disconnect() {
    this.element.classList.remove("is-enhanced")
    this.panelTargets.forEach(panel => { panel.hidden = false })
  }

  select(event) {
    this.activate(event.currentTarget)
  }

  navigate(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    let next

    if (event.key === "ArrowRight") next = this.tabTargets[(index + 1) % this.tabTargets.length]
    else if (event.key === "ArrowLeft") next = this.tabTargets[(index - 1 + this.tabTargets.length) % this.tabTargets.length]
    else if (event.key === "Home") next = this.tabTargets[0]
    else if (event.key === "End") next = this.tabTargets[this.tabTargets.length - 1]

    if (!next) return

    event.preventDefault()
    this.activate(next, true)
  }

  activate(tab, focus = false) {
    this.tabTargets.forEach(candidate => {
      const active = candidate === tab
      candidate.setAttribute("aria-selected", active ? "true" : "false")
      candidate.setAttribute("tabindex", active ? "0" : "-1")
      candidate.classList.toggle("is-active", active)

      const panel = this.panelTargets.find(item => item.id === candidate.getAttribute("aria-controls"))
      if (panel) panel.hidden = !active
    })

    if (focus) tab.focus()
  }
}
